module.exports = __webpack_public_path__ + "img/xbh.7ff159ee.png";